import { Button, type ButtonProps } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'

import { PopoverContext } from '../../provider'
import classes from '../../styles.module.css'

type CloseProps = ButtonProps & {
  onClick?: () => void
}

export function BadgeEditableClose({
  children,
  onClick,
  ...props
}: CloseProps) {
  const { t } = useTranslation('shared', { keyPrefix: 'actions' })

  const { closePopover } = React.useContext(PopoverContext)

  const handleClick = () => {
    onClick?.()
    closePopover()
  }

  return (
    <Button
      size='sm'
      variant='default'
      className={classes.close}
      onClick={handleClick}
      {...props}
    >
      {children || t('cancel')}
    </Button>
  )
}

BadgeEditableClose.displayName = 'BadgeEditable.Close'
